import { Card, Form, Button, Row } from "react-bootstrap";
import Table from "../../Components/UI/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../utils/types";
import { useEffect } from "react";
import { GetRealtimeAction } from "../../Redux/Actions/RealtimeMonitorActions";
import "./style.css";
import * as yup from "yup";
import {
  useFormik,
} from "formik";
import { convertUtcToLocal } from "../../utils/functions";
import Spinner from "../../Components/UI/Spinner/Spinner";
import CsvDownloader from "react-csv-downloader";
import { CRealtimeCommonColumns } from './CRealtimeConstant';

const RealtimeMonitor = () => {
  const dispatch = useDispatch();
  const RealtimeMonitorState = useSelector((state: IReduxState) => state.RealtimeMonitor);

  const adminState = useSelector((state: IReduxState) => state.Auth);


  const CRealtimeDataTable = RealtimeMonitorState?.bids?.map((item: any) => {
    const fixedItem: any = {};
    for (const prop in item) {
      fixedItem[prop] = item[prop]
        ? item[prop].includes(",")
          ? `"${item[prop]}"`
          : item[prop]
        : "";
    }

    return {
      ...fixedItem,
      created_at: convertUtcToLocal(fixedItem.created_at, "DD/MM/YYYY HH:mm:ss"),
      uuid: fixedItem.uuid
        ? fixedItem.uuid.split(".").length > 1
          ? fixedItem.uuid.split(".")[1]
          : fixedItem.uuid.split(".")[0]
        : "",
    };
  });

  const formik: any = useFormik({
    initialValues: {
      userId: "",
      ipAddress: "",
      ipv6: "",
      csv: false,
    },

    validationSchema: yup.object().shape(
      {
        ipAddress: yup
          .string()
          .ensure()
          .when("userId", {
            is: "",
            then: yup
              .string()
              .ensure()
              .when("ipv6", {
                is: "",
                then: yup
                  .string()
                  .required(
                    "Either IP or User ID is required"
                  )
                  .matches(
                    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i,
                    "Please use IPv4 address format (X.X.X.X)"
                  ),
              }),
            //otherwise: yup.string()
          }),
        ipv6: yup
          .string()
          .ensure()
          .when("userId", {
            is: "",
            then: yup
              .string()
              .ensure()
              .when("ipAddress", {
                is: "",
                then: yup
                  .string()
                  .required(
                    "Either IP or User ID is required"
                  )
                  .matches(
                    /^([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]?)$/i,
                    "Please use IPv6 address format (x:x:x:x:x:x:x:x)"
                  ),
              }),
            //otherwise: yup.string()
          }),
        userId: yup
          .string()
          .ensure()
          .when("ipAddress", {
            is: "",
            then: yup
              .string()
              .ensure()
              .when("ipv6", {
                is: "",
                then: yup
                  .string()
                  .required(
                    "Either IP or User ID is required"
                  ),
              }),
            // otherwise: yup.string()
          }),
      },
      [
        ["userId", "ipAddress"],
        // ["userId", "appBundle"],
        ["userId", "ipv6"],
      ]
    ),

    onSubmit: (value, { resetForm }) => {
      if (value.csv) {
      } else {
        dispatch(
          GetRealtimeAction(
            value.userId,
            value.ipAddress,
            value.ipv6
          )
        );
      }
      value.csv = false;
    },
  });

  useEffect(() => {
    dispatch(GetRealtimeAction("", "", ""));
  }, [dispatch]);
  const sizePerPageList = [
    {
      text: "10",
      value: 10,
    },
    {
      text: "25",
      value: 25,
    },
    {
      text: "50",
      value: 50,
    },
  ];
  let columns: any = [];

  
  columns = CRealtimeCommonColumns;
  

  let newColumns = columns.map((column: any) => ({
    id: column.accessor,
    displayName: column.Header,
  }));



  return (
    <>
      <Row className="d-flex justify-content-center mt-3">
        <Row>
          <h3 className="module_title" style={{ marginBottom: '0px' }}>Realtime Monitor<p>Viewing recent Ad bid data about your campaign</p></h3>
        </Row>
      </Row>
      <Card>
        <Card.Body>
          <div className="expertFilter">
            <div className="expertFilterFields">

              <div className="position-relative">
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                  className="noMargin"
                >
                  User ID
                </Form.Label>

                <Form.Control
                  id="example-date"
                  type="text"
                  name="userId"
                  className="fsz-875rem"
                  value={formik.values.userId}
                  onChange={formik.handleChange}
                  isInvalid={!!formik.errors?.userId}
                />
              </div>
              <div className="position-relative">
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                  className="noMargin"
                >
                  IPv4 Address
                </Form.Label>

                <Form.Control
                  id="example-date"
                  type="text"
                  name="ipAddress"
                  className="fsz-875rem"
                  value={formik.values.ipAddress}
                  onChange={formik.handleChange}
                  isInvalid={!!formik.errors?.ipAddress}
                />
              </div>
              <div className="position-relative">
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                  className="noMargin"
                >
                  IPv6 Address
                </Form.Label>

                <Form.Control
                  id="example-date"
                  type="text"
                  name="ipv6"
                  className="fsz-875rem"
                  value={formik.values.ipv6}
                  onChange={formik.handleChange}
                  isInvalid={!!formik.errors?.ipv6}
                />
              </div>
              <div className="btngrp">
                <Button
                  className="noMargin"
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                  variant="success"
                >
                  Apply
                </Button>

                <Button
                  onClick={() => {
                    formik.resetForm({
                      values: {
                        userId: "",
                        ipAddress: "",
                        ipv6: ""
                      },
                    });
                  }}
                  className="noMargin"
                  variant="secondary"
                >
                  Clear
                </Button>
              </div>
            </div>
            <CsvDownloader
              datas={CRealtimeDataTable}
              columns={newColumns}
              text="Export to CSV"
              filename={`realtime_monitor_` + new Date().toLocaleString()}
              extension=".csv"
              className="btn btn-primary ExportBtn no-margin"
            />
          </div>
          <div className="position-relative">
            {formik.errors.userId ? (
              <span
                style={{
                  color: "#dc3545",
                  fontFamily: "Silka",
                  fontSize: 12,
                }}
              >
                {formik.errors.userId}
              </span>
            ) : formik.errors?.ipAddress ? (
              <span
                style={{
                  color: "#dc3545",
                  fontFamily: "Silka",
                  fontSize: 12,
                }}
              >
                {formik.errors?.ipAddress}
              </span>
            ) : formik.errors?.ipv6 ? (
              <span
                style={{
                  color: "#dc3545",
                  fontFamily: "Silka",
                  fontSize: 12,
                }}
              >
                {formik.errors?.ipv6}
              </span>
            ) : null}
          </div>
          <p style={{color:'GrayText', fontSize:'110%', fontWeight: 300}}><strong>Note:</strong> When searching for User ID, add “bito.” prefix for Web ID and “mid.” prefix for GAID or IDFA</p>

          {RealtimeMonitorState?.loading && (
            <div className="popUpUser">
              <Spinner className="m-2" color={"primary"}></Spinner>
            </div>
          )}
          <Table
            columns={columns}
            data={RealtimeMonitorState?.bids}
            pageSize={10}
            sizePerPageList={sizePerPageList}
            isSortable={false}
            pagination={true}
            isSearchable={false}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default RealtimeMonitor;
